import { z } from 'zod';
import { IdSchema } from './common.js';
import { LifecycleSchema } from './catalog.js';

// ----- Depuración del catálogo (Etapa 3) -----

/** Recomendación por referencia: archivar, liquidar, revisar, mantener, o ya archivada. */
export const CleanupAdviceSchema = z.enum(['archive', 'liquidate', 'watch', 'keep', 'archived']);
export type CleanupAdvice = z.infer<typeof CleanupAdviceSchema>;

export const CleanupQuerySchema = z.object({
  /** Días sin movimiento; 0 = cualquier antigüedad. */
  days: z.coerce.number().int().min(0).max(3650).default(180),
  q: z.string().trim().max(80).optional(),
  lifecycle: LifecycleSchema.optional(),
  stock: z.enum(['zero', 'with']).optional(),
  limit: z.coerce.number().int().min(1).max(2000).default(200),
  offset: z.coerce.number().int().min(0).default(0),
});

export const CleanupRowSchema = z.object({
  product_id: z.number().int(),
  ref: z.string(),
  product_name: z.string(),
  brand: z.string(),
  category: z.string(),
  lifecycle: LifecycleSchema,
  units: z.number().int(),
  value: z.number(),
  transit_units: z.number().int(),
  open_requests: z.number().int(),
  last_movement: z.string().nullable(),
  last_sale: z.string().nullable(),
  last_entry: z.string().nullable(),
  /** Días sin movimiento; en una referencia que nunca se movió, días desde que se registró. */
  quiet_days: z.number().int(),
  recommendation: CleanupAdviceSchema,
});
export type CleanupRow = z.infer<typeof CleanupRowSchema>;

export const CleanupBoardSchema = z.object({
  days: z.number().int(),
  counts: z.record(z.string(), z.number().int()),
  candidates: z.number().int(),
  discontinued_capital: z.number(),
  total_rows: z.number().int(),
  rows: z.array(CleanupRowSchema),
});
export type CleanupBoard = z.infer<typeof CleanupBoardSchema>;

export const CleanupBulkSchema = z.object({
  product_ids: z.array(IdSchema).min(1).max(1000),
  lifecycle: LifecycleSchema,
  reason: z.string().trim().min(3).max(300),
});

export const CleanupBulkResultSchema = z.object({
  lifecycle: LifecycleSchema,
  count: z.number().int(),
  refs: z.array(z.string()),
});
export type CleanupBulkResult = z.infer<typeof CleanupBulkResultSchema>;
